export const SELECT_SLOT_OVER = 'REPORTING_SELECT_SLOT_OVER';

export const selectSlotOver = slotIndex => ({
  type: SELECT_SLOT_OVER,
  slotIndexOver: slotIndex,
});
